import { useEffect, useState } from "react";

/**
 * Rolling 24-hour countdown. Resets on every fresh visit (new tab/session).
 * Stored in sessionStorage so each new browsing session feels urgent.
 */
export function useCountdown() {
  const [remaining, setRemaining] = useState({ h: 23, m: 59, s: 59 });

  useEffect(() => {
    const KEY = "chic_countdown_deadline";
    let deadline = sessionStorage.getItem(KEY);
    if (!deadline) {
      deadline = Date.now() + 24 * 60 * 60 * 1000;
      sessionStorage.setItem(KEY, String(deadline));
    }
    deadline = Number(deadline);

    const tick = () => {
      let diff = deadline - Date.now();
      if (diff <= 0) {
        // restart for psychological urgency
        deadline = Date.now() + 24 * 60 * 60 * 1000;
        sessionStorage.setItem(KEY, String(deadline));
        diff = deadline - Date.now();
      }
      const h = Math.floor(diff / 3_600_000);
      const m = Math.floor((diff % 3_600_000) / 60_000);
      const s = Math.floor((diff % 60_000) / 1000);
      setRemaining({ h, m, s });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const pad = (n) => String(n).padStart(2, "0");
  return {
    ...remaining,
    formatted: `${pad(remaining.h)}:${pad(remaining.m)}:${pad(remaining.s)}`,
  };
}
